(ns app.front.view.escrow.account-base
  (:require [app.domain.business.model :as business-model]
            [app.domain.fee.escrow-model :as escrow-model]
            [app.front.entities :as entities]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [re-frame.std-interceptors :as interceptors]
            [schema.core :as s]))

(def ^:private state-path (interceptors/path ::state))

(rf/reg-sub ::state :-> ::state)

(rf/reg-event-fx ::fetch-account
  [state-path]
  (fn [{state :db} [_ account-id]]
    {:comm/command {:command    :fee.escrow/get-account
                    :method     :get
                    :data       (util/mmap account-id)
                    :on-success [::fetch-account.success]}
     :db           (assoc state :account-loading? true)}))

(rf/reg-event-fx ::fetch-account.success
  [state-path]
  (fn [{state :db} [_ status {:keys [entities deposit-supported?]}]]
    {:fx [[:dispatch [::entities/merge-entity-db status entities]]]
     :db (-> state
             (assoc :account-loading? false)
             (assoc :deposit-supported? deposit-supported?))}))

(rf/reg-sub ::account-loading?
  :<- [::state]
  :-> :account-loading?)

(rf/reg-sub ::deposit-supported?
  :<- [::state]
  :-> :deposit-supported?)

(defn- business-breadcrumb [{{{{:keys [account-id]} :path} :parameters} :match}]
  (when-not (<sub [::account-loading?])
    (let [account (<sub [::entities/entity account-id])
          owner   (:escrow-account/owner account)
          lang    (<sub [:language])]
      (when (= (:escrow-account/owner-type account) :escrow-account.owner-type/business)
        [:view/business
         {:business-id (:db/id owner)}
         (business-model/format-name owner lang)]))))

(rf/reg-sub ::account-number
  (fn [[_ account-id]]
    (rf/subscribe [::entities/entity account-id]))
  :-> escrow-model/account-number)

(defn- breadcrumb [{:keys [match]}]
  (let [{:keys [account-id]
         :as   params}      (-> match :parameters :path)]
    [(-> match :data :name) params (<sub [::account-number account-id])]))

(def base-route
  {:name        :view/escrow-account.base
   :parameters  {:path {:account-id s/Int}}
   :breadcrumb  {:items [business-breadcrumb
                         breadcrumb]}
   :controllers [{:parameters {:path [:account-id]}
                  :start      (fn [{{:keys [account-id]} :path}]
                                (>evt [::fetch-account account-id]))}]})
